import React, { useMemo } from 'react';
import { ChromePicker } from 'react-color';
import { RGBAObjectToRGBString } from 'swag-common/utils/colors';
import { NotecardEditorSelectWrapper } from '../notecard-editor-select-wrapper';
import { NOTECARD_EDITOR_STYLES_MAP } from '../constants';
import { getStyleValueForPrefix } from '../helpers';
import animationClasses from './notecard-editor-select-color-animation.scss';
import classes from './notecard-editor-select-color.scss';
const TEXT_COLOR = 'Text color';
const DEFAULT_COLOR = '(119, 119, 119)';
const prefix = NOTECARD_EDITOR_STYLES_MAP.COLOR_RGB_PREFIX;
export const NotecardEditorSelectColor = ({
  selectionStyles,
  handleSelectStyleChange,
  isOpened,
  toggleOpened
}) => {
  const handleSelectColor = ({
    rgb
  }) => {
    const rgbString = `(${RGBAObjectToRGBString(rgb)})`;
    handleSelectStyleChange(rgbString, prefix);
  };
  const selectedColor = useMemo(() => {
    var _getStyleValueForPref;
    return (_getStyleValueForPref = getStyleValueForPrefix(selectionStyles, prefix)) !== null && _getStyleValueForPref !== void 0 ? _getStyleValueForPref : DEFAULT_COLOR;
  }, [selectionStyles]);
  const colorCss = `rgb${selectedColor}`;
  const icon = /*#__PURE__*/React.createElement("div", {
    className: classes.colorCircle,
    style: {
      backgroundColor: colorCss
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    onFocus: e => e.stopPropagation(),
    className: classes.container
  }, /*#__PURE__*/React.createElement(NotecardEditorSelectWrapper, {
    isOpened: isOpened,
    animationClasses: animationClasses,
    name: TEXT_COLOR,
    icon: icon,
    toggleOpened: toggleOpened
  }, /*#__PURE__*/React.createElement(ChromePicker, {
    className: classes.colorPicker,
    color: colorCss,
    disableAlpha: true,
    onChange: handleSelectColor
  })));
};